export default __webpack_public_path__ + "static/media/VistaBold.eec59507.ttf";